export const lightTheme = {
  body: "#E2E2E2",
  text: "#363537",
  toggleBorder: "#6B8096",
  gradient: "linear-gradient(#39598A, #79D7ED)",
  messageBox: "#03d9c5",
  messageText: "#000000",
  chatBox: "#000000",
  button: "#2979ff",
};

export const darkTheme = {
  body: "#363537",
  text: "#FAFAFA",
  toggleBorder: "#FFF",
  gradient: "linear-gradient(#091236, #1E215D)",
  messageBox: "#ba84ff",
  messageText: "#ffffff",
  chatBox: "#ffffff",
  button: "#d68600",
};
